import { render, staticRenderFns } from "./DescriptionsViewer.vue?vue&type=template&id=6f1bf652&scoped=true&lang=pug"
import script from "./DescriptionsViewer.vue?vue&type=script&lang=js"
export * from "./DescriptionsViewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f1bf652",
  null
  
)

export default component.exports